import { Component } from "@angular/core";

@Component({
    selector: "symbol-defs",
    templateUrl: "./symbol-defs.component.html",
    standalone: false
})

export class SymbolDefsComponent {
}